import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { offersAction } from 'store';
import { selectHotOffers } from 'store/offers/selector';
import { HotOffersCarousel } from 'components/Carousels';
import { ContentContainer, CardWrapper, SliderContainer } from './styled';

export const PopularSection = () => {
  const dispatch = useDispatch();
  const hotOffers = useSelector(selectHotOffers);

  useEffect(() => {
    dispatch(offersAction.getHotOffers());
  }, []);

  return (
    <ContentContainer>
      <CardWrapper>
        <SliderContainer>
          <HotOffersCarousel hotOffers={hotOffers} />
        </SliderContainer>
      </CardWrapper>
    </ContentContainer>
  );
};
